import { useCallback } from 'react'
import { useIntl } from 'react-intl'

const useFormatMessage = () => {
  const intl = useIntl()

  return useCallback(
    (id, values = undefined) => {
      if (!id) return ''
      return intl.formatMessage({ id }, values)
    },
    [intl]
  )
}

export default useFormatMessage
